class ListService {
  async getAllListByKey(p_key) {
    try {
      const timestamp = Date.now(); //To avoid cache data
      const response = await fetch("https://app.listaki.fr/api/WS/getRefListsByUser.php?key=" + p_key + "&r=" + timestamp);
      if (!response.ok) throw new Error("Erreur lors de la récupération des listes");

      const data = await response.json();

      if (data.error) {
        return null;
      }
      else {
        // ⚠️ Adaptation : Extraction du premier tableau dans le format reçu
        const extractedLists = Array.isArray(data) && Array.isArray(data[0]) ? data[0] : [];
        return (extractedLists || []); // Assure que "lists" est bien un tableau
      }
    } catch (err) {
      console.error("Erreur getAllListByKey:", err);
    }
  };

  async getListNameByKeyAndId(p_key, p_id) {
    const lists = await this.getAllListByKey(p_key);

    // Chercher l'élément correspondant à l'ID
    const foundList = lists.find(list => list.id === p_id);

    return foundList ? foundList.name : null; // Retourne le nom ou null si non trouvé
  }

  async createRefList(p_userKey, p_newListName) {
    if (!p_newListName.trim()) return; // Vérifie que le champ n’est pas vide

    try {
      const requestOptions = {
        method: "POST",
        mode: 'cors',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          key: p_userKey,
          name: p_newListName,
        }),
      };

      const response = await fetch(`https://app.listaki.fr/api/WS/addRefList.php?key=` + p_userKey + "&name=" + p_newListName, requestOptions);

      if (!response.ok) throw new Error("Erreur lors de la création de la liste");
      if (response.error) {
        return null;
      }
      else {
        return await response.json();
      }
    } catch (err) {
      console.error("Erreur createRefList:", err);
    }
  }

  async updateListName(p_userKey, p_idList, v_newName) {
    if (!v_newName.trim()) return; // Vérifie que le champ n’est pas vide

    try {
      const requestOptions = {
        method: "POST",
        mode: 'cors',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          key: p_userKey,
          idList: p_idList,
          name: v_newName,
        }),
      };

      const response = await fetch(`https://app.listaki.fr/api/WS/updateRefList.php?key=` + p_userKey + "&id=" + p_idList + "&name=" + v_newName, requestOptions);

      if (!response.ok) throw new Error("Erreur lors de la création de la liste");
      if (response.error) {
        return null;
      }
      else {
        return await response.json();
      }
    } catch (err) {
      console.error("Erreur updateListName:", err);
    }
  }

  async deleteRefList(p_userKey, p_idList) {
    try {
      const url = `https://app.listaki.fr/api/WS/deleteRefList.php?key=${p_userKey}&id=${p_idList}`;

      const response = await fetch(url, {
        method: "POST",
        mode: 'cors',
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Erreur réseau lors de la suppression");
      }

      const data = await response.json();

      if (data.error) {
        console.error("Erreur retournée par le serveur:", data.message);
        return { success: false, message: data.message || "Erreur inconnue" };
      }

      return data;
    } catch (err) {
      console.error("Erreur deleteRefList:", err);
      return { success: false, message: err.message };
    }
  }

}

export default new ListService();